// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-btn[data-v-b0d70ac0]{text-transform:none;font-size:1em;letter-spacing:normal}", ""]);
// Exports
module.exports = exports;
